module.exports = __webpack_public_path__ + "static/media/order.2b8fbe53.png";